import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";
import { VideoSection } from "@/components/VideoSection";
import { ProductSection } from "@/components/ProductSection";
import { FeaturesSection } from "@/components/FeaturesSection";
import { SpecsSection } from "@/components/SpecsSection";
import { PricingSection } from "@/components/PricingSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <HeroSection />
      <AnnouncementBanner />
      <VideoSection />
      <ProductSection />
      <FeaturesSection />
      <SpecsSection />
      <PricingSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
